import * as React from 'react';

import { DataTableAddColumnHeader } from './data-table-add-column';
import type { DataTableColumnDef } from './data-table-types';
import { ACTIONS_COLUMN_WIDTH } from './data-table-utils';

// MODULE-LEVEL, not an inline arrow inside createActionsColumn: TanStack's
// flexRender mounts a function `header` as a component, so its IDENTITY is
// the component type. An inline arrow is a new type on every column-defs
// rebuild (any consumer dep churn), which would make React remount the header
// subtree — closing the column picker popover mid-interaction.
const ActionsColumnHeader = () => <DataTableAddColumnHeader />;

/**
 * Creates the structural actions column, pinned to the right. Its header
 * hosts the column picker's circle-plus trigger (renders nothing unless the
 * table enabled it via `onColumnVisibilityChange`). Its BODY cell renders no
 * content of its own: the row's kebab lives in the leading content cell
 * (DataTableRowKebabHost, data-table-row-kebab.tsx), and the empty sticky
 * cell is the body's right-edge fade — see the body-cell classes in
 * data-table.tsx. A table with no content
 * column at all hosts the kebab here instead (renderRow's fallback).
 */
export function createActionsColumn<TData>(): DataTableColumnDef<TData, unknown> {
  return {
    id: '__actions__',
    header: ActionsColumnHeader,
    cell: () => null,
    enableSorting: false,
    enableHiding: false,
    meta: {
      width: ACTIONS_COLUMN_WIDTH,
      // Nothing in this column truncates (a glyph, a kebab), and its header
      // fade overhangs the leading edge by 24px — `overflow-hidden` would
      // clip that overhang to the cell.
      truncate: false,
    },
  };
}
